import { EXEC_VULN_REPORT } from '../../../../shared/featureFlags/flagNames';
import { useIsFeatureEnabled } from '../../../helpers/features/featureFlags';
import { useIsSecurityEnabled } from '../../../helpers/features/security';

/**
 * Whether the Executive Vulnerability report should be shown: it needs the `execVulnReport` flag and security.
 */
export const useCanDisplayExecutiveVulnerabilityReport = (): boolean => {
  const isExecVulnReportFlagEnabled = useIsFeatureEnabled(EXEC_VULN_REPORT);
  const isSecurityEnabled = useIsSecurityEnabled();
  return isExecVulnReportFlagEnabled && isSecurityEnabled;
};
